<template>
  <div>
    <v-container>
      <v-row dense>
        <h1>{{ clientInfo.name }}</h1>
      </v-row>
    </v-container>

    <v-container grid-list-md text-xs-center>
      <v-layout row wrap>
        <v-col v-for="inspection in inspections" :key="inspection.id">
          <v-card class="mx-auto" max-width="580">
            <v-img :src="inspection.image" height="400px" />

            <v-card-title>{{ inspection.name }}</v-card-title>

            <v-card-subtitle>
              {{ inspection.description }}
            </v-card-subtitle>

            <v-card-actions>
              <v-btn text>Latest Inspection ({{ inspection['inspection_date'] }})</v-btn>
              <v-btn color="blue" text @click="onInspectionClick(inspection.id)">View</v-btn>

              <v-spacer />
            </v-card-actions>
          </v-card>
        </v-col>
      </v-layout>
      <Snackbar :type="snackBarType" :text="snackBarText" @onClose="handleSnackbarClose" />
    </v-container>
  </div>
</template>

<script>
import MetricController from '@/controllers/MetricController';
import { Snackbar, notificationType } from '@/components/widgets';

export default {
  name: 'ClientView',

  components: {
    Snackbar,
  },

  props: {},

  data() {
    return {
      clientInfo: {
        name: 'Client',
        logo: '',
      },

      inspections: [],
      snackBarText: '',
      snackBarType: notificationType.none,
    };
  },

  computed: {},

  watch: {},

  mounted() {},

  async created() {
    const [role] = this.$store.getters['session/roles'];
    try {
      const [{ data: metricData }, { data: metricChildren }] = await Promise.all([
        MetricController.getMetricData(role),
        MetricController.getMetricChildren(role, 'inspection', 2),
      ]);
      this.clientInfo.name = metricData[0].name;
      this.clientInfo.logo = metricData[0].data.logo;
      this.inspections = metricChildren.map((x) => ({
        name: x.name,
        id: x._id,
        inspection_date: x.data.inspection_date || 'No date',
        image: x.data.cover_image_url,
        description: x.data.description || '',
      }));
    } catch (error) {
      this.handleError(error);
    }
  },

  methods: {
    onInspectionClick(id) {
      this.$router.push({ path: '/inspection', query: { id } });
    },
    handleError(error) {
      this.snackBarText = error;
      this.snackBarType = notificationType.error;
    },
    handleSnackbarClose() {
      this.snackBarType = notificationType.none;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less"></style>
